import Tooltip from "../../generic-building-blocks/Tooltip";
import { useBulkSignalsInput } from "./utils";
import { ArchivedFilter } from "@avenueops/shared-types";
import { IconButton } from "@avenueops/web-components";
import { ArchiveBoxIcon, ArchiveBoxXMarkIcon } from "@heroicons/react/24/outline";
import { useDeselectAll } from "context/BulkActionsContext";
import _ from "lodash";
import React from "react";
import { useUpdateProcessesArchiveStatusMutation } from "utils/state/processes";
import { noOp } from "utils/state/utils";

interface Props {
  archived: ArchivedFilter;
  isDashboard: boolean;
}

export default function ProcessTableArchiveBulkAction({ archived, isDashboard }: Props) {
  const bulkSignalsInput = useBulkSignalsInput({ archived, isDashboard });
  const deselectAll = useDeselectAll();

  const { mutateAsync: updateProcessesArchiveStatus } = useUpdateProcessesArchiveStatusMutation({
    onSuccess: async () => {
      deselectAll();
    },
  });
  const isArchived = archived === ArchivedFilter.Enum.ARCHIVED;

  return (
    <Tooltip text={`${isArchived ? "Unarchive" : "Archive"}`} justify={"CENTER"} width="FIT" duration="duration-[5ms]">
      <IconButton
        onClick={() =>
          updateProcessesArchiveStatus({
            bulkSignalsInput,
            archive: isArchived ? false : true,
          }).catch(noOp)
        }
        type="OUTLINE"
        Icon={isArchived ? ArchiveBoxXMarkIcon : ArchiveBoxIcon}
      />
    </Tooltip>
  );
}
